import { create } from 'zustand';

import type {
  IBillingInfoFormSlice,
  IPaymentMethodsSlice,
  IPaymentButtonSlice,
  IEmailPlansSlice,
  IOrderSummarySlice,
  IAlertSlice,
  IPromoCodesSlice,
  IInboundPromoCodesSlice,
  IPrepaySelectSlice,
  ICurrencySlice,
  INonProfitSlice,
  IContactsTierSelectSlice,
  IPaymentProcessingInfoSlice,
  IPayflowTopBarSlice,
} from '../slices';
import {
  createBillingInfoFormSlice,
  createPaymentMethodsSlice,
  createPaymentButtonSlice,
  createEmailPlansSlice,
  createOrderSummarySlice,
  createAlertSlice,
  createPromoCodesSlice,
  createInboundPromoCodesSlice,
  createPrepaySelectSlice,
  createCurrencySlice,
  createNonProfitSlice,
  createContactsTierSelectSlice,
  createPaymentProcessingInfoSlice,
  createPayflowTopBarSlice,
} from '../slices';

export type IBuyNowPageStore = IBillingInfoFormSlice &
  IPaymentMethodsSlice &
  IPaymentButtonSlice &
  IPrepaySelectSlice &
  ICurrencySlice &
  INonProfitSlice &
  IContactsTierSelectSlice &
  IEmailPlansSlice &
  IOrderSummarySlice &
  IAlertSlice &
  IPromoCodesSlice &
  IInboundPromoCodesSlice &
  IPaymentProcessingInfoSlice &
  IPayflowTopBarSlice;

export const useBuyNowPageStore = create<IBuyNowPageStore>()((...args) => ({
  ...createBillingInfoFormSlice(...args),
  ...createPaymentMethodsSlice(...args),
  ...createPaymentButtonSlice(...args),
  ...createPrepaySelectSlice(...args),
  ...createCurrencySlice(...args),
  ...createNonProfitSlice(...args),
  ...createContactsTierSelectSlice(...args),
  ...createEmailPlansSlice(...args),
  ...createOrderSummarySlice(...args),
  ...createAlertSlice(...args),
  ...createPromoCodesSlice(...args),
  ...createInboundPromoCodesSlice(...args),
  ...createPaymentProcessingInfoSlice(...args),
  ...createPayflowTopBarSlice(...args),
}));
